import { useState } from "react"
import { SectionHeader } from "./section-header"

const reactionData = [
  { t: "284 ms", ok: true, color: "#00FFB3" },
  { t: "312 ms", ok: true, color: "#FF4D6D" },
  { t: "401 ms", ok: false, color: "#3DA9FC" },
  { t: "267 ms", ok: true, color: "#FFD23F" },
  { t: "298 ms", ok: true, color: "#B388FF" },
  { t: "355 ms", ok: true, color: "#00FFB3" },
]

export function Demo() {
  const [tab, setTab] = useState<"coach" | "athlete">("coach")

  return (
    <section className="py-24 md:py-32 relative overflow-hidden">
      <div
        className="absolute inset-0 -z-10 opacity-50"
        style={{ background: "radial-gradient(ellipse at center, rgba(0,255,179,0.12), transparent 60%)" }}
      />
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeader
          eyebrow="Demo"
          title={<>Veja o Kinerfy <span className="text-primary">em ação</span></>}
        />

        <div className="mt-10 flex justify-center gap-2">
          {(["coach", "athlete"] as const).map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setTab(t)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all ${
                tab === t
                  ? "bg-primary text-primary-foreground glow-primary-sm"
                  : "bg-card border border-white/10 text-muted-foreground hover:text-foreground"
              }`}
            >
              {t === "coach" ? "Tela do treinador" : "Tela de quem treina"}
            </button>
          ))}
        </div>

        <div className="mt-10 rounded-3xl border border-primary/20 bg-card/60 p-3 md:p-5 glow-primary-sm">
          {tab === "coach" ? <CoachView /> : <AthleteView />}
        </div>
        <p className="mt-4 text-center text-sm text-muted-foreground">
          Interface do treinador ou professor durante uma sessão ao vivo
        </p>
      </div>
    </section>
  )
}

function CoachView() {
  return (
    <div className="grid md:grid-cols-2 gap-3 md:gap-5">
      <div className="rounded-2xl bg-background p-6 md:p-10 flex flex-col">
        <div className="text-xs font-mono text-muted-foreground mb-4">ESTÍMULO ATUAL</div>
        <div
          className="flex-1 aspect-square rounded-2xl flex items-center justify-center text-black/80 font-extrabold"
          style={{ backgroundColor: "#00FFB3", boxShadow: "inset 0 0 80px rgba(0,0,0,0.15)" }}
        >
          <div className="text-center">
            <div className="text-sm uppercase tracking-widest opacity-70">Verde</div>
            <div className="text-4xl md:text-5xl mt-2">Toque o cone</div>
          </div>
        </div>
        <button type="button" className="mt-6 rounded-full bg-primary text-primary-foreground font-semibold py-3.5 glow-primary-sm">
          Revelar próximo estímulo
        </button>
      </div>

      <div className="rounded-2xl bg-background p-6 flex flex-col">
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="text-xs font-mono text-muted-foreground">SESSÃO</div>
            <div className="font-bold">João Silva · Color Dash</div>
          </div>
          <div className="text-right">
            <div className="text-xs text-muted-foreground">Média</div>
            <div className="text-2xl font-extrabold text-primary">319ms</div>
          </div>
        </div>
        <div className="space-y-2">
          {reactionData.map((r, i) => (
            <div
              key={i}
              className="flex items-center gap-3 rounded-xl bg-card border border-white/5 px-3 py-2.5"
            >
              <span
                className="h-3 w-3 rounded-full"
                style={{ backgroundColor: r.color, boxShadow: `0 0 8px ${r.color}` }}
              />
              <span className="font-mono text-sm flex-1">#{(i + 1).toString().padStart(2, "0")}</span>
              <span className="font-mono font-bold">{r.t}</span>
              <span
                className={`text-xs font-bold px-2 py-0.5 rounded-full ${
                  r.ok ? "bg-primary/20 text-primary" : "bg-destructive/20 text-destructive"
                }`}
              >
                {r.ok ? "ACERTO" : "ERRO"}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

function AthleteView() {
  return (
    <div className="rounded-2xl bg-background p-6 md:p-10">
      <div className="text-xs font-mono text-muted-foreground mb-4 text-center">TELA DE QUEM TREINA · TEMPO REAL</div>
      <div
        className="aspect-video rounded-2xl flex items-center justify-center"
        style={{
          backgroundColor: "#FF4D6D",
          boxShadow: "inset 0 0 120px rgba(0,0,0,0.2), 0 0 80px rgba(255,77,109,0.4)",
        }}
      >
        <span className="text-6xl md:text-8xl font-black text-black/80">VERMELHO</span>
      </div>
      <p className="mt-6 text-center text-sm text-muted-foreground">
        Quem treina vê apenas o estímulo — limpo, sem distrações. Reaja!
      </p>
    </div>
  )
}
